import NewProductSection from './NewProductSection'

export const components = {
  new_product_section: NewProductSection
}